import type { RouteRecordRaw } from "vue-router";

export const routes: RouteRecordRaw[] = [
  {
    path: "/",
    name: "Landing",
    component: () => import("@/views/landing/Index.vue"),
    meta: { title: "JoinSpark", requiresAuth: false, permission: "Landing", requirePerm: false },
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/auth/Login.vue"),
    meta: { title: "登录", requiresAuth: false, permission: "Login", requirePerm: false },
  },
  {
    path: "/auto-login",
    name: "LoginAuto",
    component: () => import("@/views/auth/LoginAuto.vue"),
    meta: { title: "自动登录", requiresAuth: false, permission: "LoginAuto", requirePerm: false },
  },
  {
    path: "/agreement",
    name: "Agreement",
    component: () => import("@/views/agreement/Index.vue"),
    meta: { title: "用户协议", requiresAuth: false, permission: "Agreement", requirePerm: false },
  },
  {
    path: "/payment-agreement",
    name: "PaymentAgreement",
    component: () => import("@/views/agreement/PaymentAgreement.vue"),
    meta: { title: "JoinSpark付费服务协议", requiresAuth: false, permission: "PaymentAgreement", requirePerm: false },
  },
  {
    path: "/privacy",
    name: "Privacy",
    component: () => import("@/views/privacy/Index.vue"),
    meta: { title: "隐私政策", requiresAuth: false, permission: "Privacy", requirePerm: false },
  },
  {
    path: "/points-rules",
    name: "PointsRules",
    component: () => import("@/views/agreement/PointsRules.vue"),
    meta: { title: "积分规则", requiresAuth: false, permission: "PointsRules", requirePerm: false },
  },
  {
    path: "/data-sharing-agreement",
    name: "DataSharingAgreement",
    component: () => import("@/views/agreement/DataSharingAgreement.vue"),
    meta: { title: "账号授权与数据共享协议", requiresAuth: false, permission: "DataSharingAgreement", requirePerm: false },
  },
  {
    path: "/ai-content-guidelines",
    name: "AIContentGuidelines",
    component: () => import("@/views/agreement/AIContentGuidelines.vue"),
    meta: { title: "AI内容生成服务使用规范", requiresAuth: false, permission: "AIContentGuidelines", requirePerm: false },
  },
  {
    path: "/report/detail/:task_id",
    name: "ReportDetail",
    component: () => import("@/views/report/detail.vue"),
    meta: { title: "创意报告", requiresAuth: true, permission: "ReportDetail", requirePerm: false },
  },
  {
    path: "/report/download/:task_id",
    name: "ReportDownload",
    component: () => import("@/views/report/download.vue"),
    meta: { title: "创意报告下载", requiresAuth: false, permission: "ReportDownload", requirePerm: false },
  },
  {
    path: "/app",
    component: () => import("@/views/layouts/MainLayout.vue"),
    redirect: "/app/dashboard",
    meta: { requiresAuth: false, permission: "App", requirePerm: false },
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        component: () => import("@/views/dashboard/index.vue"),
        meta: { title: "仪表盘", requiresAuth: false, permission: "Dashboard", requirePerm: false },
      },
      {
        path: "/creative/video",
        name: "VideoGeneration",
        component: () => import("@/views/generation/index.vue"),
        meta: {
          title: "视频创作",
          requiresAuth: true,
          permission: "VideoGeneration",
          requirePerm: true,
          creativeType: "video",
        },
      },
      {
        path: "/creative/image",
        name: "ImageGeneration",
        component: () => import("@/views/generation/index.vue"),
        meta: {
          title: "图片创作",
          requiresAuth: true,
          permission: "ImageGeneration",
          requirePerm: true,
          creativeType: "image",
        },
      },
      {
        path: "/creative/text",
        name: "TextGeneration",
        component: () => import("@/views/generation/index.vue"),
        meta: {
          title: "脚本创作",
          requiresAuth: true,
          permission: "TextGeneration",
          requirePerm: true,
          creativeType: "text",
        },
      },
      {
        path: "/community/report",
        name: "ReportList",
        component: () => import("@/views/report/index.vue"),
        meta: { title: "创意报告", requiresAuth: true, permission: "Report", requirePerm: true },
      },
      {
        path: "/community/report/create",
        name: "CommunityReportCreate",
        component: () => import("@/views/report/create.vue"),
        meta: { title: "创意报告创建", requiresAuth: true, permission: "Report", requirePerm: true },
      },
      {
        path: "/community/list",
        name: "CommunityIndex",
        component: () => import("@/views/community/index.vue"),
        meta: { title: "创意社区", requiresAuth: true, permission: "Community", requirePerm: true },
      },
      {
        path: "/community/advertisers",
        name: "Advertisers",
        component: () => import("@/views/community/Advertisers.vue"),
        meta: {
          title: "广告主",
          requiresAuth: true,
          permission: "Advertisers",
          requirePerm: true,
        },
      },
      {
        path: "/community/:ad_key",
        name: "CommunityDetail",
        component: () => import("@/views/community/detail.vue"),
        meta: { title: "创意社区详情", requiresAuth: true, permission: "Community", requirePerm: true },
      },
      {
        path: "/history/list",
        name: "HistoryList",
        component: () => import("@/views/history/list.vue"),
        meta: { title: "历史创作", requiresAuth: true, permission: "HistoryList", requirePerm: true },
      },
      {
        // 灵感解析详情
        path: "/inspiration/analysis/:task_id",
        name: "InspirationAnalysis",
        component: () => import("@/views/inspiration/InspirationAnalysis.vue"),
        meta: { title: "", requireAuth: true, permission: "InspirationAnalysis", requirePerm: true },
      },
      {
        path: "/material/collection",
        name: "MaterialCollection",
        component: () => import("@/views/material/collection.vue"),
        meta: { title: "创意收藏", requiresAuth: true, permission: "MaterialCollection", requirePerm: true },
      },
      {
        path: "/team",
        name: "TeamIndex",
        component: () => import("@/views/team/index.vue"),
        meta: { title: "团队管理", requiresAuth: true, permission: "TeamIndex", requirePerm: false },
        children: [
          {
            path: "notification",
            name: "TeamNotification",
            component: () => import("@/views/team/components/TeamNotification.vue"),
            meta: { title: "团队管理", requiresAuth: true, permission: "TeamNotification", requirePerm: false },
          },
          {
            path: "index",
            name: "TeamManagement",
            component: () => import("@/views/team/manage.vue"),
            meta: { title: "团队管理", requiresAuth: true, permission: "TeamManagement", requirePerm: false },
          },
          {
            path: "memberRecord",
            name: "MemberRecord",
            component: () => import("@/views/team/memberRecord.vue"),
            meta: { title: "成员使用记录", requiresAuth: true, permission: "MemberRecord", requirePerm: false },
          },
        ],
      },
      {
        path: "/no-permission",
        name: "NoPermission",
        component: () => import("@/views/layouts/NoPermission.vue"),
        meta: { title: "暂无权限", requiresAuth: false },
      },
    ],
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: () => import("@/views/layouts/404.vue"),
    meta: { title: "页面不存在", requiresAuth: false },
  },
];
